export const useShowMapLoading = (
  loading: Ref<boolean>,
  clustersLoading: Ref<boolean>,
  assetsLoading: Ref<boolean>,
  clusterZoomLevel: Ref<number>,
  currentZoom: Ref<number>,
) => {
  const currentLoadingAbortController = ref<AbortController | null>(null)

  const showLoading = ref(false)

  const isLoading = computed(() => {
    if (clustersLoading.value || loading.value) {
      return true
    }

    if (clusterZoomLevel.value <= currentZoom.value) {
      return assetsLoading.value
    }

    return false
  })

  watch(isLoading, async () => {
    // Abort previous loading since the loading value changed
    if (currentLoadingAbortController.value) {
      currentLoadingAbortController.value.abort()
    }

    const abortController = new AbortController()

    currentLoadingAbortController.value = abortController

    if (!isLoading.value) {
      showLoading.value = false
      return
    }

    // Wait 200 seconds to avoid flickering
    await new Promise((resolve) => setTimeout(resolve, 200))

    if (abortController.signal.aborted) {
      return
    }

    showLoading.value = isLoading.value
  })

  return {
    showLoading,
  }
}
